export const CAST_HEADER_CONSTANTS = {
    STORAGE_KEY: 'cast_data',
    MOBILE_CAST_HEADER: '.dcl-cast-member-header.mobile',
    PAGE_CONTAINER_ID: 'cruise-destination-list-layout'
};
